import type { ShipmentStatus } from '../types/shipment';

type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

const LABELS: Record<ShipmentStatus, string> = {
  CREATED: 'Зареєстровано',
  IN_TRANSIT: 'В дорозі',
  ARRIVED: 'Прибуло',
  DELIVERED: 'Отримано',
  RETURNED: 'Повернення',
  CANCELLED: 'Скасовано',
  ERROR: 'Помилка',
};

const COLORS: Record<ShipmentStatus, ChipColor> = {
  CREATED: 'info',
  IN_TRANSIT: 'primary',
  ARRIVED: 'primary',
  DELIVERED: 'success',
  RETURNED: 'warning',
  CANCELLED: 'default',
  ERROR: 'error',
};

export function shipmentStatusLabel(status: ShipmentStatus): string {
  return LABELS[status];
}

export function shipmentStatusColor(status: ShipmentStatus): ChipColor {
  return COLORS[status];
}
